import AddBilling from '../../event/components/AddBilling';

export default function AddOrEditBill({ model, setModel }) {
  return (
    <AddBilling BillingModel={model} setBillingModel={setModel} alwaysBilled />
  );
}
